import React, { Children, useEffect, useRef, useState } from 'react'
import Box from '@mui/material/Box'
import Popper from '@mui/material/Popper'
import Icon from '@mui/material/Icon'

const AdxPopper = ({
  customButton,
  buttonIcon = 'more_horiz-rounded',
  linePlacement,
  children,
  popperId = 'AdxPopper',
  sx,
  childBoxSx,
  closeOnClick = 'all',
  iconProps = {},
  customPopper,
  disabled,
  ...rest
}) => {
  const refButton = useRef(null)
  const refPopper = useRef(null)
  const arrayChidren = Children.toArray(children)
  const [anchorEl, setAnchorEl] = useState(null)
  const [buttonWidth, setButtonWidth] = useState(0)

  const handleClick = (event) => {
    if (!disabled) setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const open = Boolean(anchorEl)
  const id = open ? popperId : undefined

  useEffect(() => {
    if (refButton.current) {
      setButtonWidth(refButton.current.offsetWidth)
    }
  }, [refButton, open])

  useEffect((e) => {
    const checkIfClickedOutside = (e) => {
      // If the menu is open and the clicked target is not within the menu,
      // then close the menu
      if (
        open &&
        refPopper.current &&
        !refPopper.current.contains(e.target) &&
        refButton.current &&
        !refButton.current.contains(e.target)
      ) {
        setAnchorEl(false)
      }
    }

    document.addEventListener('mousedown', checkIfClickedOutside)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  })

  return (
    <>
      <Box
        onClick={handleClick}
        display="flex"
        alignItems="center"
        justifyContent="center"
        ref={refButton}
        width={'fit-content'}
        sx={{ cursor: 'pointer' }}
      >
        {customButton || (
          <Icon
            aria-describedby={id}
            type="button"
            sx={{ color: 'light-gray-text.main' }}
            {...iconProps}
          >
            {buttonIcon}
          </Icon>
        )}
      </Box>
      {arrayChidren.length > 0 ? (
        <Popper id={id} open={open} anchorEl={anchorEl} style={{ zIndex: 10000 }} {...rest}>
          <Box
            ref={refPopper}
            sx={{
              border: '1px solid',
              borderColor: 'gray-line.main',
              borderRadius: '4.5px',
              bgcolor: 'white.main',
              minWidth: buttonWidth || 'auto',
              boxShadow: 2,
              ...sx,
            }}
          >
            {arrayChidren.map((item, index1) => (
              <React.Fragment key={index1}>
                {linePlacement
                  ? linePlacement.map((item, index2) =>
                      item === index1 ? (
                        <Box
                          key={index2}
                          borderBottom="1px solid"
                          sx={{ borderColor: 'gray-line.main' }}
                        />
                      ) : null
                    )
                  : null}
                <Box
                  key={index1}
                  margin={customPopper ? null : 0.5}
                  paddingY={customPopper ? null : 1}
                  paddingX={customPopper ? null : 1.5}
                  borderRadius={1}
                  onClick={
                    closeOnClick === 'all'
                      ? () => setAnchorEl(false)
                      : closeOnClick === 'none'
                      ? null
                      : (e) => {
                          if (e.target.type === closeOnClick) {
                            setAnchorEl(false)
                          }
                        }
                  }
                  sx={{
                    cursor: 'pointer',
                    color: 'dark-text.main',
                    '&:hover': {
                      bgcolor: !item.type.name ? 'gray-background.main' : null,
                    },
                    ...childBoxSx,
                  }}
                >
                  {item}
                </Box>
              </React.Fragment>
            ))}
          </Box>
        </Popper>
      ) : null}
    </>
  )
}

export default AdxPopper
